export const OKTA = {
  CLIENT_ID: '0oaw5tenfspyruAuJ697',
  ORG_DOMAIN: 'integrator-7909563.okta.com',
  TOKEN_STORAGE_KEY: 'okta-token-storage',
};
